/**
 * Whether a KPI carries an actual measurement.
 *
 * The KPI of an optimization process are written only when its pipeline
 * completes, so a queued, running, aborted or failed process holds `null` in
 * them and must be shown as `N/A` rather than as a measured zero. Zero is
 * itself a legitimate result, hence the explicit checks: a falsy test would
 * hide a real zero behind the same `N/A` as a missing value.
 */
export const hasKpiValue = (
  value: number | null | undefined
): value is number =>
  value !== null && value !== undefined && !Number.isNaN(value)
